// Merkezi fetch wrapper — JWT'yi localStorage'dan okur, Authorization header ekler,
// 401'de token'ı temizleyip uygulamayı login ekranına düşürür ("auth:logout" event).
const TOKEN_KEY = "medreg_token";

export const getToken = (): string | null => localStorage.getItem(TOKEN_KEY);
export const setToken = (t: string): void => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = (): void => localStorage.removeItem(TOKEN_KEY);

export async function apiFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const token = getToken();
  const headers = new Headers(init.headers);
  if (token) headers.set("Authorization", `Bearer ${token}`);
  const res = await fetch(input, { ...init, headers });
  if (res.status === 401) {
    clearToken();
    window.dispatchEvent(new Event("auth:logout"));
    throw new Error("unauthorized");
  }
  return res;
}

// withToken — download/preview linkleri (<a href>, window.open) Authorization header
// gönderemez; backend access_token query param fallback'ini destekler (middleware/auth.go).
export function withToken(url: string): string {
  const token = getToken();
  if (!token) return url;
  return url + (url.includes("?") ? "&" : "?") + "access_token=" + encodeURIComponent(token);
}
